import {
    TOOL_NEWSLETTER_CONTEXT,
    TOOL_NEWSLETTER_STEPS
} from "@omni/services/tracking/trackers/tools/newsletter/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@omni/services/tracking/trackers/utils";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

export const trackStart = () => {
    ToolsStepTracker.track(
        TOOL_NEWSLETTER_STEPS.start,
        TOOL_NEWSLETTER_CONTEXT
    );
};

export const trackSubmit = (newsLetterResult: any) => {
    if (!newsLetterResult) return;

    const customerid = createUserId(newsLetterResult.email);
    const step: StepVariables = {
        ...TOOL_NEWSLETTER_STEPS.submit,
        result: {
            customerid: customerid,
            storeId: newsLetterResult.storeId
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_NEWSLETTER_CONTEXT);
};
